if (!customElements.get('collection-view')) {
  class CollectionView extends HTMLElement {
    constructor() {
      super();
      this.columnOptions = ['4', '6', '8'];
      this.init();
    }

    init() {
      this.setupEventListeners();
      if (!Shopify.designMode) this.restoreSavedColumns();
    }

    setupEventListeners() {
      this.addEventListener('click', (e) => {
        const button = e.target.closest('.js-btn');
        if (!button) return;
        
        const cols = button.dataset.cols;
        if (!this.columnOptions.includes(cols)) return;
        
        this.updateGridColumns(cols);
      });
    }

    restoreSavedColumns() {
      const savedCols = localStorage.getItem('collection-grid-cols');
      if (savedCols && this.columnOptions.includes(savedCols)) {
        this.updateGridColumns(savedCols, true);
      }
    }

    updateGridColumns(cols, initialLoad = false) {
      const grid = document.querySelector('#product-grid');
      if (!grid) return;
      
      // Update UI
      const activeButton = this.querySelector('.js-btn[disabled]');
      const newButton = this.querySelector(`.js-btn[data-cols="${cols}"]`);
      
      if (activeButton) activeButton.removeAttribute('disabled');
      if (newButton) newButton.setAttribute('disabled', '');
      
      // Update grid
      grid.dataset.cols = cols;
      
      // Save preference
      if (!initialLoad && !Shopify.designMode) {
        localStorage.setItem('collection-grid-cols', cols);
      }
    }
  }

  customElements.define('collection-view', CollectionView);
}